import { SiteActivityEvent, generator } from '@cms-max/cms-browser-api-client'
import { GeneratorArgs } from './generateEventMap'
import { Activity, Component } from '@cms-max/medicare-api-sdk'

export const premiumsLandingGenerator = generator(({ i18n }: GeneratorArgs) => {
  const createPremiumsLandingLinkClickHandler = (elementId: string) => (
    params: {
    linkText?: string,
    linkUrl?: string
  }): SiteActivityEvent => ({
    core: {
      elementId,
      property: 'MAX',
      activity: Activity.LinkClick,
      component: Component.Premiums,
      coreClickData: {
        linkText: params.linkText,
        linkUrl: params.linkUrl
      }
    }
  })

  return {
    premiums_landingpage_setupeasypay_click: createPremiumsLandingLinkClickHandler(
      'premiums_landingpage_setupeasypay_click'
    ),
    premiums_landingpage_easypaypage_click: createPremiumsLandingLinkClickHandler(
      'premiums_landingpage_easypaypage_click'
    ),
    premiums_landingpage_changeeasypay_click: createPremiumsLandingLinkClickHandler(
      'premiums_landingpage_changeeasypay_click'
    ),
    premiums_landingpage_ssaccount_click: createPremiumsLandingLinkClickHandler(
      'premiums_landingpage_ssaccount_click'
    ),
    premiums_landingpage_premiumdetails_click: createPremiumsLandingLinkClickHandler(
      'premiums_landingpage_premiumdetails_click'
    ),
    premiums_landingpage_recentpayments_click: createPremiumsLandingLinkClickHandler(
      'premiums_landingpage_recentpayments_click'
    ),
    premiums_landingpage_paynow_click: createPremiumsLandingLinkClickHandler(
      'premiums_landingpage_paynow_click'
    ),
    premiums_landingpage_currentandpastbills_click: createPremiumsLandingLinkClickHandler(
      'premiums_landingpage_currentandpastbills_click'
    )
  }
})

export type premiumsLandingKeys = keyof ReturnType<
  typeof premiumsLandingGenerator
>

export default premiumsLandingGenerator
